'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgTextShort = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { d: "M4.699 5.055c-.242.077-.371.177-.491.381-.097.165-.108.223-.108.564 0 .343.011.398.111.569a.862.862 0 0 0 .3.3l.189.111 7.294.011c4.823.006 7.344-.004 7.444-.03.389-.105.603-.395.633-.857.031-.485-.109-.803-.433-.984l-.178-.1-7.3-.008c-5.797-.006-7.333.003-7.461.043m.035 3.823a.858.858 0 0 0-.524.395c-.099.168-.11.225-.11.567 0 .343.011.398.111.569a.862.862 0 0 0 .3.3l.189.111h7.76l.178-.1c.298-.167.442-.452.442-.88s-.144-.713-.442-.88l-.178-.1-3.8-.006c-2.09-.004-3.857.007-3.926.024", fillRule: "evenodd", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgTextShort);

exports["default"] = ForwardRef;
//# sourceMappingURL=TextShort.js.map
